/* Carrito lateral: añadir sin salir de la página, cambiar cantidades, subir de pack y venta cruzada. */
(function () {
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var lastFocus = null;
  function drawer() { return document.getElementById('CartDrawer'); }
  function setCount(n) {
    document.querySelectorAll('.pm-cart__count').forEach(function (el) { el.textContent = n; });
  }
  function open() {
    var d = drawer(); if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.documentElement.classList.add('pm-cd-open');
    var p = d.querySelector('.pm-cd__panel'); if (p) p.focus();
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.hidden = true;
    document.documentElement.classList.remove('pm-cd-open');
    if (lastFocus) lastFocus.focus();
  }
  function refresh(keepOpen) {
    return fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (json) {
      var html = json['cart-drawer']; if (!html) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('#CartDrawer'); var d = drawer();
      if (fresh && d) {
        var wasOpen = !d.hidden;
        fresh.hidden = !keepOpen;
        /* si ya estaba abierto, no repetir la entrada deslizante */
        if (wasOpen && keepOpen) fresh.classList.add('is-static');
        d.replaceWith(fresh);
        if (wasOpen && keepOpen) { var p = fresh.querySelector('.pm-cd__panel'); if (p) p.focus({ preventScroll: true }); }
      }
      return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
    }).then(syncGift);
  }

  /* Oferta de bienvenida: con un código que empieza por el prefijo del tema (cookie discount_code, que Shopify
     guarda al entrar por /discount/CÓDIGO) y un pack de 12 o más, añade los 3 geles de regalo; sin pack, los quita.
     El descuento de Shopify es el que los deja a 0 €. */
  var syncing = false;
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function cookie(name) { var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function syncGift() {
    var d = drawer(); var g = d && d.querySelector('[data-welcome-gift]');
    if (syncing || !g) return;
    var prefix = (g.getAttribute('data-prefix') || '').toUpperCase();
    var hasCode = prefix && cookie('discount_code').toUpperCase().indexOf(prefix) === 0;
    var ok = g.getAttribute('data-qualifies') === 'true';
    var line = +g.getAttribute('data-gift-line') || 0;
    var req = null;
    /* El regalo es siempre la variante del tema (3 geles, uno de cada sabor): no se elige */
    var giftId = +g.getAttribute('data-variant');
    var current = +g.getAttribute('data-gift-current') || 0;
    if (hasCode && ok && !line && store('pmWelcomeGiftOff') !== '1') req = post('cart/add.js', { items: [{ id: giftId, quantity: 1, properties: { _regalo: 'bienvenida' } }] });
    else if (line && !ok) req = post('cart/change.js', { line: line, quantity: 0 });
    else if (line && ok && current && current !== giftId) req = post('cart/change.js', { line: line, quantity: 0 }).then(function () { return post('cart/add.js', { items: [{ id: giftId, quantity: 1, properties: { _regalo: 'bienvenida' } }] }); });
    if (!req) return;
    syncing = true;
    return req.then(function () { syncing = false; return refresh(!drawer().hidden); }, function () { syncing = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncGift); else syncGift();
  /* Tras pedir el código en el pop-up: repintar el carrito para que el regalo entre si ya hay un pack */
  document.addEventListener('pm:welcome', function () { refresh(false); });
  /* Si quitan el regalo a mano, no volver a añadirlo (vuelve si piden otra vez el código) */
  document.addEventListener('click', function (e) { if (e.target.closest('[data-cd-gift-rm]')) store('pmWelcomeGiftOff', '1'); }, true);
  function busy(on) { var d = drawer(); if (d) d.classList.toggle('is-busy', on); }
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
  }

  /* Añadir al carrito desde cualquier formulario de producto */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!drawer() || !form.matches('form[action*="/cart/add"]')) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw er; }); return r.json(); })
      .then(function () { return refresh(true); })
      .then(open)
      .catch(function (er) { alert((er && (er.description || er.message)) || 'No se ha podido añadir al carrito.'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var cartLink = t.closest('a.pm-cart');
    if (cartLink && drawer()) { e.preventDefault(); refresh(true).then(open); return; }
    if (t.closest('[data-cd-close]')) { close(); return; }

    var q = t.closest('[data-cd-qty]');
    if (q) {
      busy(true);
      post('cart/change.js', { line: +q.getAttribute('data-cd-qty'), quantity: Math.max(0, +q.getAttribute('data-to')) })
        .then(function () { return refresh(true); }).finally(function () { busy(false); });
      return;
    }
    var s = t.closest('[data-cd-swap]');
    if (s) {
      busy(true);
      post('cart/change.js', { line: +s.getAttribute('data-cd-swap'), quantity: 0 })
        .then(function () {
          var item = { id: +s.getAttribute('data-variant'), quantity: +s.getAttribute('data-qty') || 1 };
          /* conserva la suscripción de la línea */
          if (s.getAttribute('data-selling-plan')) item.selling_plan = +s.getAttribute('data-selling-plan');
          return post('cart/add.js', { items: [item] });
        })
        .then(function () { return refresh(true); }).finally(function () { busy(false); });
      return;
    }
    var a = t.closest('[data-cd-add]');
    if (a) {
      busy(true);
      post('cart/add.js', { items: [{ id: +a.getAttribute('data-cd-add'), quantity: 1 }] })
        .then(function () {
          /* en la página del carrito, recargar para ver la línea; en el resto, abrir el carrito lateral */
          if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
          return refresh(true).then(open);
        }).finally(function () { busy(false); });
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || d.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    /* foco atrapado dentro del carrito */
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(
      d.querySelectorAll('.pm-cd__panel a[href], .pm-cd__panel button:not([disabled]), .pm-cd__panel input, .pm-cd__panel [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], act = document.activeElement;
    if (e.shiftKey && (act === first || !d.contains(act) || act.classList.contains('pm-cd__panel'))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (act === last || !d.contains(act))) { e.preventDefault(); first.focus(); }
  });
})();
